/**
 * Where the NexBorg Access app is got (C1-15). Android by its package id (`com.nexborg.access`); the App Store
 * address needs Apple's numeric id, which exists only once the app is listed — until then a page says
 * what to search for rather than linking to nothing.
 *
 * Shared since the Staff setup guide (G-2b, 2026-10-01): its last step prints the same links as the
 * employee-only page, and a staff module may not import from auth (rules/01 §1).
 */
export const MOBILE_APP_LINKS = {
  android: "https://play.google.com/store/apps/details?id=com.nexborg.access",
  ios: null as string | null,
  name: "NexBorg Access",
} as const;
